// ============================================================
// FILE: web-app/src/index.js
// Dark Mode + Ant Design ConfigProvider
// ============================================================

import React, { useState, createContext, useContext } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ConfigProvider, theme } from 'antd';
import viVN from 'antd/locale/vi_VN';
import dayjs from 'dayjs';
import 'dayjs/locale/vi';
import App from './App';
import './index.css';
import './styles/responsive.css';

dayjs.locale('vi');

// ============================================================
// THEME CONTEXT (tích hợp trong index.js)
// ============================================================
const ThemeContext = createContext({
  isDarkMode: false,
  toggleDarkMode: () => {},
});

// Export hook để components khác sử dụng
export const useTheme = () => useContext(ThemeContext);

// ============================================================
// ROOT COMPONENT
// ============================================================
const Root = () => {
  const [isDarkMode, setIsDarkMode] = useState(() => {
    const saved = localStorage.getItem('theme');
    return saved === 'dark';
  });

  const toggleDarkMode = () => {
    setIsDarkMode(prev => {
      const newValue = !prev;
      localStorage.setItem('theme', newValue ? 'dark' : 'light');
      return newValue;
    });
  };

  const themeConfig = {
    algorithm: isDarkMode ? theme.darkAlgorithm : theme.defaultAlgorithm,
    token: {
      colorPrimary: '#1890ff',
      borderRadius: 6,
    },
  };

  return (
    <ConfigProvider locale={viVN} theme={themeConfig}>
      <ThemeContext.Provider value={{ isDarkMode, toggleDarkMode }}>
        <div className={isDarkMode ? 'app-dark' : 'app-light'}>
          <App />
        </div>
      </ThemeContext.Provider>
    </ConfigProvider>
  );
};

// ============================================================
// RENDER
// ============================================================
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Root />
    </BrowserRouter>
  </React.StrictMode>
);